import {type ReactNode} from 'react';
import {cn} from '@lib/utils';
import {
  Empty,
  EmptyContent,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from '@ui/shadcn/empty';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: ReactNode;
  className?: string;
}

/** Состояние пустого списка — обёртка над `shadcn/empty`. */
export const EmptyState = ({
  icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps) => (
  <Empty className={cn('gap-3 p-10', className)}>
    <EmptyHeader className='gap-1'>
      {icon && (
        <EmptyMedia variant='default' className='mb-3 text-muted-foreground'>
          {icon}
        </EmptyMedia>
      )}
      <EmptyTitle className='text-sm font-medium'>{title}</EmptyTitle>
      {description && (
        <EmptyDescription className='max-w-xs text-xs'>
          {description}
        </EmptyDescription>
      )}
    </EmptyHeader>
    {action && <EmptyContent className='mt-1'>{action}</EmptyContent>}
  </Empty>
);
